<select class="select" [ngClass]="size" [formControl]="control" (change)="onChange($event)">
  <option value="" [disabled]="placeHolder ? false : true" [selected]="true">
    {{ placeHolder }}
  </option>
  <option *ngFor="let option of options" [value]="option.value">
    {{ option.text }}
  </option>
</select>
